import { render, staticRenderFns } from "./handmadePrescriptionConfirm.vue?vue&type=template&id=383f3777&scoped=true"
import script from "./handmadePrescriptionConfirm.vue?vue&type=script&lang=js"
export * from "./handmadePrescriptionConfirm.vue?vue&type=script&lang=js"
import style0 from "./handmadePrescriptionConfirm.vue?vue&type=style&index=0&id=383f3777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f3777",
  null
  
)

export default component.exports